import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Tally ERP 9 Basics",
  "Inventory Management",
  "GST Implementation",
  "Financial and Accounting Reports",
  "Payroll Management",
  "Banking and Taxation",
  "Real-world Projects and Case Studies",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive Tally training with expert mentors." },
  { title: "Certification Preparation",      desc: "Prepare for Tally certification exam." },
  { title: "Live Projects & Case Studies",   desc: "Work on real accounting scenarios." },
  { title: "Monthly Assessment & Feedback",  desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Industry-recognised certification on completion." },
];
const Tally = () => (
  <CourseDetailTemplate title="Tally Certification Course"
    description="Become a certified Tally expert and enhance your accounting skills! Learn Tally ERP 9, GST, inventory management, and financial reporting. Boost your career with hands-on projects and industry-relevant knowledge."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Tally ERP 9", "GST", "Payroll", "Accounting", "Inventory"]}
    programName="Tally Certification Course"
  />
);
export default Tally;
